interface Ifoot {
  apiData: any;
}
const getTotal = (apiData: any) => {
  let output = [];
  let totalSum = 0;
  for (let i = 0; i < 31; i++) {
    let sum = 0;
    for (const partName in apiData) {
      sum += apiData[partName][i];
    }
    totalSum += sum;
    output.push(<th>{sum}</th>);
  }
  output.push(<th>{totalSum}</th>);
  return output;
};
const TFoot = ({ apiData }: Ifoot) => {
  return (
    <tfoot>
      <tr style={{ background: 'yellow' }}>
        <th colSpan={3}>DAY WISE TOTAL REJECTION</th>
        {getTotal(apiData)}
      </tr>
    </tfoot>
  );
};

export default TFoot;
